import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import MaskedInput from 'react-text-mask';
import CurrencyInput from 'react-currency-input';
import {
  Button, Col, DatePicker, Input, message, Modal,
  Row, Select, Spin, Form, Checkbox, notification,
} from 'antd';
import {
  DeleteFilled,
} from '@ant-design/icons';
import {
  get, put, post, isSuperAgentError,
  RequestWrapper, ResponseWrapper,
} from '../../../../dataSource/requests';
import './EditEstimate.scss';
import SelectedLands from '../../serviceComponents/selectedLands/SelectedLands';
import DynamicFields from '../../../sharedComponents/dynamicFields/DynamicFields';
import { getUserType, getUserName } from '../../../../utils/users';
import ServiceStatusComponent from '../../../sharedComponents/serviceStatusComponent/ServiceStatusComponent';
import UploadFiles from '../../serviceComponents/uploadFiles/UploadFiles';
import ServiceRequestFieldsRenderer from '../../serviceComponents/serviceRequestFields/ServiceRequestFields';
import { formatTelephone } from '../../../../utils/format';
import { isRestructuredService } from '../../../../utils/constants';
import GridFields from '../../serviceComponents/gridFields/GridFields';

const dateFormat = 'DD/MM/YYYY';

const EditEstimate = (): JSX.Element => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formInstance] = Form.useForm();
  const uploadFilesReference = useRef(null);
  const { TextArea } = Input;

  const [visibleModalStatus, setVisibleModalStatus] = useState<boolean>(false);
  const [visibleModalConfirmStatus, setVisibleModalConfirmStatus] = useState<boolean>(false);
  const [userType] = useState(getUserType());
  const [serviceTypeDynamicFields, setServiceTypeDynamicFields] = useState([]);
  const [serviceSubtypeDynamicFields, setServiceSubtypeDynamicFields] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [visibleModalResponsable, setVisibleModalResponsable] = useState<boolean>(false);
  const [formValueTemp, setFormValueTemp] = useState([]);
  const [generatedNumbers] = useState([]);
  const [dataAttachments, setDataAttachments] = useState([]);
  const [dataId, setDataId] = useState(null);
  const [dataLandFields, setDataLandFields] = useState([]);
  const [dataLandName, setDataLandName] = useState<string|null>(null);
  const [dataLandOwnerName, setDataLandOwnerName] = useState<string|null>(null);
  const [dataMatriculationNumber, setDataMatriculationNumber] = useState<string|null>(null);
  const [dataReasonForCancellation, setDataReasonForCancellation] = useState<string|null>(null);
  const [hasSubType, setHasSubType] = useState(null);
  const [serviceRequestFields, setServiceRequestFields] = useState([]);
  const [allRequestData, setAllRequestData] = useState({});
  const [isRestructured, setIsRestructured] = useState<boolean>(false);
  const [dataTelephone, setDataTelephone] = useState<string|null>(null);
  const [dataResponsableUserId, setDataResponsableUserId] = useState<number>(0);
  const [dataSchedulingDate, setDataSchedulingDate] = useState({
    dynamicFieldId: null,
    id: null,
    name: null,
    value: null,
  });

  const [dataServiceName, setDataServiceName] = useState<string|null>(null);
  const [dataServiceSubTypeName, setDataServiceSubTypeName] = useState<string|null>(null);

  const [dataServiceSubtypeDynamicFields, setDataServiceSubtypeDynamicFields] = useState([]);
  const [dataServiceTypeName, setDataServiceTypeName] = useState<string|null>(null);
  const [dataServiceTypeId, setDataServiceTypeId] = useState(null);

  const [dataServiceTypeDynamicFields, setDataServiceTypeDynamicFields] = useState([]);
  const [solicitationDate, setSolicitationDate] = useState(null);
  const [dataStatus, setDataStatus] = useState(null);
  const [dataResponsableBudget, setDataResponsableBudget] = useState(null);
  const [dataReasonRefuses, setDataReasonRefuses] = useState(null);
  const [dataDescriptionRefuse, setDataDescriptionRefuse] = useState(null);

  const [
    dataUserNameThatRequestedTheService,
    setDataUserNameThatRequestedTheService,
  ] = useState(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [statusesList, setStatusesList] = useState([]);
  const [currentStatusIndex, setCurrentStatusIndex] = useState(0);
  const [canceled, setCanceled] = useState<boolean>(false);
  const [obsArrayInit, setObsArrayInit] = useState([]);
  const [obsArray, setObsArray] = useState([]);
  const valueAttachmentSizeCooperated = useRef(null);
  const valueAttachmentSizeCoopercitrus = useRef(null);
  const [requestedBranch, setRequestedBranch] = useState<boolean>(true);
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [ctcResponsavel, setCTCResponsavel] = useState<string|null>(null);
  const [nomeFilial, setNomeFilial] = useState<string|null>(null);

  const currencyFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const dataShare = {
    attachments: dataAttachments,
    id: dataId,
    landFields: dataLandFields,
    landName: dataLandName,
    landOwnerName: dataLandOwnerName,
    matriculationNumber: dataMatriculationNumber,
    reasonForCancellation: dataReasonForCancellation,
    responsableUserId: dataResponsableUserId,
    schedulingDate: dataSchedulingDate,
    serviceName: dataServiceName,
    telephone: dataTelephone,
    serviceSubtypeName: dataServiceSubTypeName,
    serviceSubtypeDynamicFields: dataServiceSubtypeDynamicFields,
    serviceTypeName: dataServiceTypeName,
    serviceTypeId: dataServiceTypeId,
    serviceTypeDynamicFields: dataServiceTypeDynamicFields,
    solicitationDate,
    status: dataStatus,
    userNameThatRequestedTheService: dataUserNameThatRequestedTheService,
  };

  const handleNotifys = (response) => {
    const notificationArguments = {
      message: 'Notification Title',
      description: 'Description',
      icon: '',
    };

    switch (response.code) {
      case 13003:
        notificationArguments.message = 'Sucesso';
        notificationArguments.description = 'O orçamento foi gravado com sucesso!';
        notification.success(notificationArguments);

        break;
      default:
        break;
    }
  };

  const reorder = (arrayOfFields) => {
    const fields = arrayOfFields;

    function insertAt(array, index, a) {
      array.splice(index, 0, a);
    }

    let newFields = [];

    if (fields.length > 0) {
      newFields = fields.filter((field) => field.conditionFieldId == null);
      newFields.sort((a, b) => a.id < b.id);

      let haveFieldToBeSorted = true;

      while (haveFieldToBeSorted) {
        haveFieldToBeSorted = false;

        for (let iCount = fields.length - 1; iCount >= 0; iCount--) {
          const field = fields[iCount];

          if (field.conditionFieldId != null) {
            const indexDependencyField = newFields
              .filter((field1) => field1.id == field.conditionFieldId);

            if (indexDependencyField.length === 0) {
              haveFieldToBeSorted = true;
            } else if (!newFields.includes(field)) {
              const indexDependencyFieldIndex = newFields.indexOf(indexDependencyField[0]);

              insertAt(newFields, indexDependencyFieldIndex + 1, field);
            }
          }
        }
      }
    }
    return newFields;
  };

  const testConditional = (referenceValue, comparison, expectedValue, type) => {
    if (type === 'LONG') { }

    if (type === 'BOOLEAN') { }

    if (type === 'DATE') { }

    if (type === 'STRING') { }

    if (comparison === 'IN') {
      const objExpected = JSON.parse(expectedValue);
      return objExpected.some((obj) => obj === referenceValue);
    }

    if (comparison === 'EQUAL') {
      return referenceValue?.toString() === expectedValue?.toString();
    }

    if (comparison === 'GREATER') {
      return referenceValue > expectedValue;
    }

    if (comparison === 'GREATER_EQUAL') {
      return referenceValue >= expectedValue;
    }

    if (comparison === 'LESS') {
      return referenceValue < expectedValue;
    }

    if (comparison === 'LESS_EQUAL') {
      return referenceValue <= expectedValue;
    }

    if (comparison === 'BETWEEN') {
      const expectedValueArray = expectedValue.split(';');
      return referenceValue <= expectedValueArray[0] && expectedValueArray[1] <= referenceValue;
    }

    return true;
  };

  const mask = (rawValue) => {
    if (rawValue.length > 14) {
      return [
        '(',
        /[1-9]/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ];
    }
    return [
      '(',
      /[1-9]/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  };

  const getValueSystemParameters = async () => {
    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    try {
      const getSystemParametersReqRef: RequestWrapper = get({
        url: '/system/getSystemParameters',

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await getSystemParametersReqRef;
    } catch (error) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      } else {
        genericError = error as Error;
      }
    }

    switch (true) {
      case (response?.body?.code === 8001):
        // "System parameters got successfully", 8001
        valueAttachmentSizeCooperated.current = response?.body
          .getSystemParametersOutput
          .attachmentSizeCooperated;

        valueAttachmentSizeCoopercitrus.current = response?.body
          .getSystemParametersOutput
          .attachmentSizeCoopercitrus;
        break;

      case (responseError?.body?.code === -4001):
        // "You must be authenticated to perform this operation", -4001
        break;

      case (responseError?.body?.code === -4003):
        // "You do not have permission to perform this operation", -4003
        notification.error({
          message: 'Erro',
          description: 'Desculpe, você não possui permissão para executar esta ação.',
        });
        break;

      case (genericError?.message?.includes('has been aborted')):
        // dont show anything when request is aborted
        break;

      case (responseError?.body?.code === -4000):
      default:
        // "Something unexpected happened", -4000
        notification.error({
          message: 'Erro',
          description: 'Ocorreu um erro ao buscar informações, tente novamente.',
        });
        break;
    }
  };

  useEffect(() => {
    formInstance.setFieldsValue({ responsableUser: dataResponsableUserId });
  }, [dataResponsableUserId]);

  useEffect(() => {
    getValueSystemParameters();

    const loadTypeDynamicFields = async (idArgument) => {
      let response: ResponseWrapper | undefined;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      try {
        const typeDynamicFieldReqRef: RequestWrapper = get({
          url: `/service/typeDynamicField/${idArgument}`,

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        response = await typeDynamicFieldReqRef;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }
      }

      switch (true) {
        case (response?.body?.code === 5001): {
          // "Dynamic fields listed successfully", 5001
          const dynamicReordered = reorder(response?.body.serviceTypeDynamicFields);
          setServiceTypeDynamicFields(dynamicReordered);
        } break;
  
        case (responseError?.body?.code === -4001):
          // "You must be authenticated to perform this operation", -4001
          break;
  
        case (responseError?.body?.code === -4003):
          // "You do not have permission to perform this operation", -4003
          notification.error({
            message: 'Erro',
            description: 'Desculpe, você não possui permissão para executar esta ação.',
          });
          break;
  
        case (genericError?.message?.includes('has been aborted')):
          // dont show anything when request is aborted
          break;
  
        case (responseError?.body?.code === -4000):
        default:
          // "Something unexpected happened", -4000
          notification.error({
            message: 'Erro',
            description: 'Ocorreu um erro ao buscar os campos do serviço, tente novamente',
          });
          break;
      }
    };

    const loadSubtypeDynamicFields = async (idArgument, idCultura) => {
      let response: ResponseWrapper | undefined;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      try {
        const subtypeDynamicFieldReqRef: RequestWrapper = get({
          url: `/service/subtypeDynamicField/${idArgument}/${idCultura}`,

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        response = await subtypeDynamicFieldReqRef;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }
      }

      switch (true) {
        case (response?.body?.code === 5001): {
          // "Dynamic fields listed successfully", 5001
          const dynamicReordered = reorder(response?.body.serviceSubtypeDynamicFields);
          setServiceSubtypeDynamicFields(dynamicReordered);
        } break;
  
        case (responseError?.body?.code === -5003):
          // "Service subtype not found", -5003
          notification.error({
            message: 'Erro',
            description: 'Subtipo de serviço não encontrado.',
          });
          break;

        case (responseError?.body?.code === -4001):
          // "You must be authenticated to perform this operation", -4001
          break;
  
        case (responseError?.body?.code === -4003):
          // "You do not have permission to perform this operation", -4003
          notification.error({
            message: 'Erro',
            description: 'Desculpe, você não possui permissão para executar esta ação.',
          });
          break;
  
        case (genericError?.message?.includes('has been aborted')):
          // dont show anything when request is aborted
          break;
  
        case (responseError?.body?.code === -4000):
        default:
          // "Something unexpected happened", -4000
          notification.error({
            message: 'Erro',
            description: 'Ocorreu um erro ao buscar os campos do serviço, tente novamente.',
          })
          break;
      }
    };

    const loadResponsableUser = async () => {
      let response: ResponseWrapper | undefined;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      try {
        const adminFindAllActivatedReqRef: RequestWrapper = get({
          url: '/admin/findAllActivated',

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        response = await adminFindAllActivatedReqRef;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }
      }

      switch (true) {
        case (response?.body?.code === 1009):
          // "All users listed successfully", 1009
          setUserOptions(response?.body.coopercitrusUsers.map(
            (v) => (
              <Select.Option
                key={v.id}
                value={v.id}
              >
                {v.name}
              </Select.Option>
            ),
          ));
          break;

        case (responseError?.body?.code === -1007):
          // "User not found", -1007
          notification.error({
            message: 'Erro',
            description: 'Usuário não encontrado.',
          });
          break;
  
        case (responseError?.body?.code === -4001):
          // "You must be authenticated to perform this operation", -4001
          break;
  
        case (responseError?.body?.code === -4003):
          // "You do not have permission to perform this operation", -4003
          notification.error({
            message: 'Erro',
            description: 'Desculpe, você não possui permissão para executar esta ação.',
          });
          break;
  
        case (genericError?.message?.includes('has been aborted')):
          // dont show anything when request is aborted
          break;
  
        case (responseError?.body?.code === -4000):
        default:
          // "Something unexpected happened", -4000
          notification.error({
            message: 'Erro',
            description: 'Erro ao carregar a listagem de usuários responsáveis.',
          });
          break;
      }
    };

    const loadStatusData = async (idArgument) => {
      let response: ResponseWrapper | undefined;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      try {
        const listBudgetStatusFlowReqRef: RequestWrapper = get({
          url: `/budget/listBudgetStatusFlow/${idArgument}`,

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        response = await listBudgetStatusFlowReqRef;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }
      }

      switch (true) {
        case (response?.body?.code === 13012): {
          // "Budget flow listed successfully", 13012
          const statusesListResponse = response?.body.budgetStatusFlowOutputs;
          setStatusesList(statusesListResponse);
          setCurrentStatusIndex(statusesListResponse.reduce((a, v) => (a + !!v.date), -1));
          setCanceled(!!statusesListResponse.find((v) => v.reasonForCancellation));
        } break;

        case (responseError?.body?.code === -14003):
          // "Budget not found", -14003
          notification.error({
            message: 'Erro',
            description: 'Orçamento não encontrado.',
          });
          break;
  
        case (responseError?.body?.code === -4001):
          // "You must be authenticated to perform this operation", -4001
          break;
  
        case (responseError?.body?.code === -4003):
          // "You do not have permission to perform this operation", -4003
          notification.error({
            message: 'Erro',
            description: 'Desculpe, você não possui permissão para executar esta ação.',
          });
          break;
  
        case (genericError?.message?.includes('has been aborted')):
          // dont show anything when request is aborted
          break;
  
        case (responseError?.body?.code === -4000):
        default:
          // "Something unexpected happened", -4000
          notification.error({
            message: 'Erro',
            description: 'Ocorreu um erro ao buscar o fluxo de status, tente novamente.',
          });
          break;
      }
    };

    const loadData = async (idArgument) => {
      let response: ResponseWrapper | undefined;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      setLoading(true);

      try {
        const findBudgetRequestDetails: RequestWrapper = get({
          url: `/budget/coopercitrus/findBudgetRequestDetails/${idArgument}`,

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        response = await findBudgetRequestDetails;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }
      }

      setLoading(false);

      switch (true) {
        case (response?.body?.code === 13007): {
          // "Budget request found successfully", 13007

          setAllRequestData(response?.body.details);

          if (response?.body.details.budgetRequestNotes) {
            setObsArray(response?.body.details.budgetRequestNotes);

            const test = JSON.parse(JSON.stringify(response?.body.details.budgetRequestNotes));

            setObsArrayInit(test);
          }

          if (response?.body.details.serviceSubtypeId) {
            loadSubtypeDynamicFields(
              response?.body.details.serviceSubtypeId,
              response?.body.details.landFields[0].culture === 'Cana açúc'
                ? '051'
                : null,
            );
            setHasSubType(true);
          } else {
            loadTypeDynamicFields(response?.body.details.serviceTypeId);
            setHasSubType(false);
          }

          setCTCResponsavel(response?.body.details.ctc);
          setNomeFilial(response?.body.details.branchCoopercitrus.name);
          setServiceRequestFields(response?.body.details.budgetRequestFields);
          setDataAttachments(response?.body.details.attachments);
          setDataId(id);
          setDataLandFields(response?.body.details.landFields);
          setDataLandName(response?.body.details.landName);
          setDataLandOwnerName(response?.body.details.landOwnerName);
          setDataMatriculationNumber(response?.body.details.matriculationNumber);
          setDataReasonForCancellation(response?.body.details.reasonForCancellation);
          setDataResponsableUserId(response?.body.details.responsableUserId);
          setDataSchedulingDate(response?.body.details.schedulingDate);
          formInstance.setFieldsValue({
            schedulingDate: response?.body.details.schedulingDate?.value ? moment(response?.body.details.schedulingDate.value, 'YYYY-MM-DDTHH:mm:ss.SSSZZ').utc() : null,
          });
          setDataServiceName(response?.body.details.serviceName);
          setDataTelephone(response?.body.details.telephone);
          formInstance.setFieldsValue({ telephone: formatTelephone(response?.body.details.telephone) });
          setDataServiceSubTypeName(response?.body.details.serviceSubtypeName);
          setDataServiceTypeName(response?.body.details.serviceTypeName);
          setDataServiceTypeId(response?.body.details.serviceTypeId);

          const serviceFullName = `${response?.body.details.serviceName} ${(response?.body.details?.serviceTypeName) ? response?.body.details?.serviceTypeName : ''} ${(response?.body.details?.serviceSubtypeName) ? response?.body.details?.serviceSubtypeName : ''}`;

          setIsRestructured(isRestructuredService(serviceFullName));
          setDataServiceSubtypeDynamicFields(response?.body.details.serviceSubtypeDynamicFields);
          setDataServiceTypeDynamicFields(response?.body.details.serviceTypeDynamicFields);
          setSolicitationDate(response?.body.details.solicitationDateTime);
          setDataStatus(response?.body.details.status);
          setDataReasonRefuses(response?.body.details.reasonRefuses);
          setDataDescriptionRefuse(response?.body.details.descriptionRefuse);
          setDataResponsableBudget(response?.body.details.responsableBudget);
          setDataUserNameThatRequestedTheService(response?.body.details.userNameThatRequestedTheService);
          formInstance.setFieldsValue(
            {
              valorTotal: currencyFormatter.format(response?.body.details.amount),
            },
          );
          formInstance.setFieldsValue(
            {
              formaPagamento: response?.body.details.formOfPayment,
            },
          );
          formInstance.setFieldsValue(
            {
              condicaoPagamento: response?.body.details.paymentTerms,
            },
          );
          formInstance.setFieldsValue(
            {
              valorUnitario: currencyFormatter.format(response?.body.details.unitaryValue),
            },
          );

          formInstance.setFieldsValue(
            {
              obsOrcamento: response?.body.details.budgetNotes,
            },
          );

          if (
            response?.body.details.status === 'Orçamento pendente'
            || response?.body.details.status === 'Orçamento recusado'
            || response?.body.details.status === 'Orçamento expirado'
          ) {
            setRequestedBranch(false);
          }

          setLoading(false);
        } break;

        case (responseError?.body?.code === -14009):
          // "Budget request not found", -14009
          notification.error({
            message: 'Erro',
            description: 'Solicitação de orçamento não encontrada.',
          });
          break;
  
        case (responseError?.body?.code === -4001):
          // "You must be authenticated to perform this operation", -4001
          break;
  
        case (responseError?.body?.code === -4003):
          // "You do not have permission to perform this operation", -4003
          notification.error({
            message: 'Erro',
            description: 'Desculpe, você não possui permissão para executar esta ação.',
          });
          break;
  
        case (genericError?.message?.includes('has been aborted')):
          // dont show anything when request is aborted
          break;
  
        case (responseError?.body?.code === -4000):
        default:
          // "Something unexpected happened", -4000
          notification.error({
            message: 'Erro',
            description: 'Ocorreu um erro ao buscar os detalhes, tente novamente.'
          });
          break;
      }
    };

    if (getUserType() !== 'COOPERCITRUS') {
      navigate(`/service/estimates/${id}/details/`);
    }

    loadResponsableUser();
    loadData(id);
    loadStatusData(id);

    return () => {
      setLoading(false);
    };
  }, []);

  const getFormatedValues = (item, value) => {
    if (item.typeValue === 'BOOLEAN') {
      if (typeof value === 'boolean') {
        return value;
      }
      // Tipo grid volta uma array
      return !!value.length;
    }

    if (item.typeValue === 'DATE') {
      return moment(value).format(dateFormat);
    }

    return value;
  };

  const showModal = (value) => {
    const uploadError = !uploadFilesReference.current.validateFiles();

    if (!uploadError) {
      setFormValueTemp(value);
      setVisibleModalResponsable(true);
    } else {
      message.error('Erro ao validar arquivo.');
    }
  };

  const handleSubmit = async (values) => {
    let finalValues;
    const paramsCooperEditNotes = [];
    const paramsCooperDeleteNotes = [];
    const paramsCooperAddNotes = [];

    for (const key in obsArrayInit) {
      if (!obsArray.some((a) => a.id === obsArrayInit[key].id)) {
        paramsCooperDeleteNotes.push({ id: obsArrayInit[key].id });
      }
    }

    for (const index in obsArray) {
      if (obsArrayInit.some((a) => a.id === obsArray[index].id)) {
        const obsContrl = obsArrayInit.filter((a) => a.id === obsArray[index].id)[0];
        const valText = formInstance.getFieldValue(`text${obsArray[index].id}`);

        if (
          valText !== obsArray[index].notes
          || obsContrl.privateNotes !== obsArray[index].privateNotes
        ) {
          obsArray[index].notes = valText;
          paramsCooperEditNotes.push(obsArray[index]);
        }
      } else {
        const valText = formInstance.getFieldValue(`text${obsArray[index].id}`);
        obsArray[index].notes = valText;
        delete obsArray[index].id;
        paramsCooperAddNotes.push(obsArray[index]);
      }
    }

    finalValues = await formInstance.validateFields();

    const uploadError = !uploadFilesReference.current.validateFiles();
    const dataArrayDynamics = [];

    if (!isRestructured) {
      for (const ind in serviceTypeDynamicFields) {
        console.log(serviceTypeDynamicFields[ind]);
      }

      for (const ind in dataServiceSubtypeDynamicFields) {
        dataArrayDynamics.push(dataServiceSubtypeDynamicFields[ind]);
      }

      for (const ind in dataServiceTypeDynamicFields) {
        dataArrayDynamics.push(dataServiceTypeDynamicFields[ind]);
      }
    }

    let data;

    if (hasSubType) {
      data = {
        schedulingDate: dataSchedulingDate,
        serviceSubtypeDynamicFields: dataArrayDynamics,
      };
    } else {
      data = {
        schedulingDate: dataSchedulingDate,
        serviceTypeDynamicFields: dataArrayDynamics,
      };
    }

    setLoading(true);

    if (!uploadError) {
      try {
        await uploadFilesReference.current.handleSubmitFiles();
      } catch (error) {
        setLoading(false);
        return;
      }

      const params = {};
      params.budgetRequestId = id;

      if (paramsCooperEditNotes.length > 0) {
        const paramsEditRequest = {};
        paramsEditRequest.serviceRequestNotes = paramsCooperEditNotes;

        try {
          const editBudgetRequestNotesReqRef: RequestWrapper = put({
            url: `/budget/editBudgetRequestNotes/${params.budgetRequestId}`,
            params: paramsEditRequest,

            frontConfigs: {
              navigateFunction: navigate,
            },
          });

          await editBudgetRequestNotesReqRef;
        } catch (error) {
          setLoading(false);
          return;
        }
      }

      if (paramsCooperAddNotes.length > 0) {
        const paramsAddRequest = {};
        paramsAddRequest.serviceRequestNotes = paramsCooperAddNotes;

        try {
          const addBudgetRequestNotesReqRef: RequestWrapper = post({
            url: `/budget/addBudgetRequestNotes/${params.budgetRequestId}`,
            params: paramsAddRequest,

            frontConfigs: {
              navigateFunction: navigate,
            },
          });

          await addBudgetRequestNotesReqRef;
        } catch (error) {
          setLoading(false);
          return;
        }
      }

      if (paramsCooperDeleteNotes.length > 0) {
        const paramsDeleteRequest = {};
        paramsDeleteRequest.serviceRequestNotes = paramsCooperDeleteNotes;

        try {
          const deleteBudgetRequestNotesReqRef: RequestWrapper = put({
            url: `/budget/deleteBudgetRequestNotes/${params.budgetRequestId}`,
            params: paramsDeleteRequest,

            frontConfigs: {
              navigateFunction: navigate,
            },
          });

          await deleteBudgetRequestNotesReqRef;
        } catch (error) {
          setLoading(false);
          return;
        }
      }

      if (values.responsableUser) {
        params.responsableUserId = values.responsableUser;
      }

      if (values.telephone) {
        params.telephone = values.telephone.replace(/\D/g, '');
      }

      if (values.schedulingDate) {
        params.schedulingDate = {
          dynamicFieldId: data.schedulingDate.dynamicFieldId,
          id: data.schedulingDate.id,
          value: values.schedulingDate.format('YYYY-MM-DDTHH:mm:ss.SSSZZ'),
        };
      }

      if (values.reasonForCancellation) {
        params.reasonForCancellation = values.reasonForCancellation;
      }

      const novoServiceTypeDynamicFields = [];

      if (!isRestructured) {
        serviceTypeDynamicFields.forEach((v) => {
          let value = formInstance.getFieldValue(`dynamicField${v.id}`);

          const dynamicField = data
            .serviceTypeDynamicFields
            .find((df) => df.dynamicFieldId === v.id);

          if (v.conditionComparison) {
            const referenceValue = formInstance.getFieldValue(`dynamicField${v.conditionFieldId}`);

            if (!testConditional(
              referenceValue,
              v.conditionComparison,
              v.conditionExpectedValue,
              v.typeValue,
            )) {
              value = undefined;
            }
          }

          if (value !== undefined) {
            novoServiceTypeDynamicFields.push({
              id: dynamicField ? dynamicField.id : null,
              dynamicFieldId: v.id,

              value: getFormatedValues(
                v, formInstance.getFieldValue(`dynamicField${v.id}`),
              ),
            });
          }
        });
      }

      const novoServiceSubtypeDynamicFields = [];

      if (!isRestructured) {
        serviceSubtypeDynamicFields.forEach((v) => {
          let value = formInstance.getFieldValue(`subtypeDynamicFields${v.id}`);

          const dynamicField = data
            .serviceSubtypeDynamicFields
            .find((df) => df.dynamicFieldId === v.id);

          if (v.conditionComparison) {
            const referenceValue = formInstance.getFieldValue(`subtypeDynamicFields${v.conditionFieldId}`);
            if (!testConditional(
              referenceValue,
              v.conditionComparison,
              v.conditionExpectedValue,
              v.typeValue,
            )) {
              value = undefined;
            }
          }

          if (value !== undefined) {
            novoServiceSubtypeDynamicFields.push({
              id: dynamicField ? dynamicField.id : null,
              dynamicFieldId: v.id,
              value: getFormatedValues(v, value),
            });
          }
        });
      }

      params.serviceTypeDynamicFields = novoServiceTypeDynamicFields || [];
      params.serviceSubtypeDynamicFields = novoServiceSubtypeDynamicFields || [];

      let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

      if (isRestructured) {
        const fields = Object.entries(finalValues);
        params.serviceRequestFieldInputList = fields.map((fieldValue) => {
          const campoEncontrado = serviceRequestFields.find((val) => val.idCode === fieldValue[0]);
          return ({
            idCode: fieldValue[0],
            value: fieldValue[1],
            id: campoEncontrado?.id,
          });
        }).filter((fieldValue) => {
          return !(fieldValue.value == null && fieldValue.id == null);
        }).filter((fieldValue) => {
          return fieldValue.idCode.includes('GEOFERT')
            || fieldValue.idCode.includes('SPRAY_DRONE')
            || fieldValue.idCode.includes('VANT')
            || fieldValue.idCode.includes('SATELITE')
            || fieldValue.idCode.includes('APLICACAO_CORRETIVOS');
        });
      }

      try {
        const editBudgetRequestReqRef: RequestWrapper = put({
          url: '/budget/editBudgetRequest',
          params,

          frontConfigs: {
            navigateFunction: navigate,
          },
        });

        response = await editBudgetRequestReqRef;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }
      }

      setLoading(false);

      switch (true) {
        case (response?.body?.code === 13011):
          // "Budget request edited successfully", 13011
          notification.success({
            message: 'Sucesso',
            description: 'Orçamento editado com sucesso',
          });

          navigate(`/service/estimates/${id}/details`);
          break;
        
        case (responseError?.body?.code === -14003):
          // "Budget not found", -14003
          notification.error({
            message: 'Erro',
            description: 'Orçamento não encontrado.',
          });
          break;
        
        case (responseError?.body?.code === -1007):
          // "User not found", -1007
          notification.error({
            message: 'Erro',
            description: 'Usuário não encontrado.',
          });
          break;

        case (responseError?.body?.code === -5023):
          // "Telephone can not be null", -5023
          notification.error({
            message: 'Erro',
            description: 'Telefone não pode ser vazio.',
          });
          break;

        case (responseError?.body?.code === -4001):
          // "You must be authenticated to perform this operation", -4001
          break;
  
        case (responseError?.body?.code === -4003):
          // "You do not have permission to perform this operation", -4003
          notification.error({
            message: 'Erro',
            description: 'Desculpe, você não possui permissão para executar esta ação.',
          });
          break;
  
        case (genericError?.message?.includes('has been aborted')):
          // dont show anything when request is aborted
          break;
  
        case (responseError?.body?.code === -4000):
        default:
          // "Something unexpected happened", -4000
          message.error('Erro ao atualizar o orçamento');
          break;
      }
    } else {
      setLoading(false);
    }
  };

  const filter = () => {
    return (f) => f.name !== 'Valor unitário'
      && f.name !== 'Valor total'
      && f.name !== 'Condição de pagamento'
      && f.name !== 'Forma de pagamento'
      && f.name !== 'Observações do orçamento';
  };

  const addObs = () => {
    setLoading(true);

    const ctrl = [];

    for (const key in obsArray) {
      ctrl.push(obsArray[key]);
    }

    let uniqueId = false;
    let newId;

    while (!uniqueId) {
      newId = Math.random();

      if (!generatedNumbers.some((a) => a === newId)) {
        uniqueId = true;
      }
    }

    ctrl.push(
      {
        notes: '',
        privateNotes: true,
        type: 'COOPERCITRUS',
        id: `${newId}temp`,
      },
    );

    generatedNumbers.push(newId);
    setObsArray(ctrl);
    setLoading(false);
  };

  const removeObs = (index) => {
    setLoading(true);

    const ctrl = [];

    for (const key in obsArray) {
      ctrl.push(obsArray[key]);
    }

    ctrl.splice(index, 1);
    setObsArray(ctrl);
    setLoading(false);
  };

  const changeChecked = (index) => {
    setLoading(true);

    const test = [];

    for (const key in obsArray) {
      test.push(obsArray[key]);
    }

    test[index].privateNotes = !test[index].privateNotes;
    setObsArray(test);
    setLoading(false);
  };

  const renderObs = (coopercitrus) => {
    const items = [];
    const b = obsArray;

    for (const index in obsArray) {
      if (
        (coopercitrus && obsArray[index].type === 'COOPERCITRUS')
        || (!coopercitrus && obsArray[index].type !== 'COOPERCITRUS')) {
        items.push(
          <Col
            className="colObs"
          >
            <Row>
              <Form.Item
                label=""
                name={`text${obsArray[index].id}`}
                initialValue={obsArray[index].notes}
                shouldUpdate
                rules={[
                  {
                    required: true, message: 'Não é possível adicionar uma observação vazia',
                  },
                  {
                    max: 1000, message: 'O número máximo de caracteres pra observações é de 1000',
                  },
                ]}
              >
                <TextArea
                  className="obsCooper"
                  xs={{ span: 24 }}
                  lg={{ span: 24 }}
                  rows={4}
                  value={b[index].notes}
                  disabled={!coopercitrus}
                />
              </Form.Item>
            </Row>
            <Row
              justify="space-between"
              className="RowPrivado"
            >
              <Row
                style={{ cursor: 'pointer' }}
                onClick={
                  obsArray[index].type === 'COOPERCITRUS'
                    ? () => changeChecked(index)
                    : () => { }
                }
              >
                <Form.Item
                  label=""
                  name={`check${index}`}
                >
                  <Checkbox
                    checked={obsArray[index].privateNotes}
                  />
                </Form.Item>
                <div
                  className="privadoText"
                >
                  <p>
                    Privado
                  </p>
                </div>
              </Row>
              <DeleteFilled
                className="deleteControl"
                onClick={
                  obsArray[index].type === 'COOPERCITRUS'
                    ? () => removeObs(index)
                    : () => { }
                }
              />
            </Row>
          </Col>,
        );
      }
    }

    return (
      <Col>
        {items}
      </Col>
    );
  };

  const validateSchedulingDate = (rule, value) => {
    if (!value) {
      return Promise.reject(new Error('Por favor, insira data de agendamento.'));
    }

    if (moment(value).endOf('day') <= moment().endOf('day')) {
      return Promise.reject(new Error(`Insira uma data maior que ${moment().format(dateFormat)}`));
    }

    return Promise.resolve();
  };

  const renderDynamicField = (field) => {
    let fieldData;

    if (field.conditionFieldId) {
      fieldData = dataServiceSubtypeDynamicFields.find((v) => v.dynamicFieldId === field.id);
    } else {
      fieldData = dataServiceSubtypeDynamicFields.find((v) => v.name === field.name);
    }

    if (!fieldData) {
      if (field.conditionFieldId) {
        fieldData = dataServiceTypeDynamicFields.find((v) => v.dynamicFieldId === field.id);
      } else {
        fieldData = dataServiceTypeDynamicFields.find((v) => v.name === field.name);
      }
    }

    if (!fieldData) {
      fieldData = {
        value: undefined,
      };
    }

    return (
      <DynamicFields
        field={{ ...fieldData, ...field }}
        form={formInstance}
        type="dynamicField"
        key={`type-${field.id}`}
        edit={true}
      />
    );
  };

  const renderSubtypeDynamicField = (field) => {
    let fieldData;

    if (field.conditionFieldId) {
      fieldData = dataServiceSubtypeDynamicFields.find((v) => v.dynamicFieldId === field.id);
    } else {
      fieldData = dataServiceSubtypeDynamicFields.find((v) => v.name === field.name);
    }

    if (!fieldData) {
      if (field.conditionFieldId) {
        fieldData = dataServiceTypeDynamicFields.find((v) => v.dynamicFieldId === field.id);
      } else {
        fieldData = dataServiceTypeDynamicFields.find((v) => v.name === field.name);
      }
    }

    if (!fieldData) {
      fieldData = {
        value: undefined,
      };
    }

    return (
      <DynamicFields
        field={{ ...fieldData, ...field }}
        form={formInstance}
        type="subtypeDynamicFields"
        key={`type-${field.id}`}
        edit={true}
      />
    );
  };

  const verifyRequiredFormBranch = () => {
    let searchNull = false;

    if (!formInstance.getFieldValue('valorUnitario')) {
      searchNull = true;
    }

    if (!formInstance.getFieldValue('valorTotal')) {
      searchNull = true;
    }

    if (!formInstance.getFieldValue('condicaoPagamento')) {
      searchNull = true;
    }

    if (!formInstance.getFieldValue('formaPagamento')) {
      searchNull = true;
    }

    return searchNull;
  };

  const handleSubmitBranch = async () => {
    setLoading(true);
    setConfirmLoading(true);

    const requiredFormBranch = verifyRequiredFormBranch();
    if (requiredFormBranch) {
      message.warning('Por favor, preencha os campos obrigatórios de orçamento.');
      setLoading(false);
      setConfirmLoading(false);
      setVisibleModalConfirmStatus(false);
      return;
    }

    const targetAmount = Number(formInstance.getFieldValue('valorTotal').toString()
      .replaceAll('.', '')
      .replaceAll(',', '.')
      .replaceAll(' ', '')
      .replaceAll('R$', ''));
    const targetUnitaryValue = Number(formInstance.getFieldValue('valorUnitario').toString()
      .replaceAll('.', '')
      .replaceAll(',', '.')
      .replaceAll(' ', '')
      .replaceAll('R$', ''));

    const data = {
      amount: targetAmount,
      budgetId: +id,
      budgetNotes: formInstance.getFieldValue('obsOrcamento'),
      formOfPayment: formInstance.getFieldValue('formaPagamento'),
      paymentTerms: formInstance.getFieldValue('condicaoPagamento'),
      unitaryValue: targetUnitaryValue,
    };

    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    try {
      const requestMakingTheBudgetReqRef: RequestWrapper = post({
        url: '/budget/requestMakingTheBudget',
        params: data,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await requestMakingTheBudgetReqRef;
    } catch (error) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      } else {
        genericError = error as Error;
      }
    }

    setLoading(false);
    setConfirmLoading(false);

    switch (true) {
      case (response?.body?.code === 13003):
        // "making the budget added successfully", 13003
        handleNotifys(response?.body);
        setDataStatus('Aguardando aceite do orçamento');
        setDataResponsableBudget(getUserName());
        setRequestedBranch(true);
        setVisibleModalConfirmStatus(false);
        break;

      case (responseError?.body?.code === -14004):
        // "No negative value allowed", -14004
        notification.error({
          message: 'Erro',
          description: 'Valores negativos não são permitidos.',
        });
        break;

      case (responseError?.body?.code === -14003):
        // "Budget not found", -14003
        notification.error({
          message: 'Erro',
          description: 'Orçamento não encontrado.',
        });
        break;

      case (responseError?.body?.code === -14005):
        // "Not allowed to edit", -14005
        notification.error({
          message: 'Erro',
          description: 'Edição não permitida.',
        });
        break;

      case (responseError?.body?.code === -4001):
        // "You must be authenticated to perform this operation", -4001
        break;

      case (responseError?.body?.code === -4003):
        setVisibleModalConfirmStatus(false);
        // "You do not have permission to perform this operation", -4003
        notification.error({
          message: 'Erro',
          description: 'Desculpe, você não possui permissão para executar esta ação.',
        });
        break;

      case (genericError?.message?.includes('has been aborted')):
        // dont show anything when request is aborted
        break;

      case (responseError?.body?.code === -4000):
      default:
        setVisibleModalConfirmStatus(false);
        // "Something unexpected happened", -4000
        notification.error({
          message: 'Erro',
          description: 'Ocorreu um erro ao salvar orçamento, tente novamente',
        });
        break;
    }
  };

  return (
    <div className="EditEstimate">
      <Spin
        tip="Carregando..."
        spinning={loading}
      >
        <Form
          scrollToFirstError
          form={formInstance}
          layout="vertical"
          onFinish={(value) => showModal(value)}
          onFinishFailed={
            (errorInfo) => {
              console.log('EditEstimate onFinishFailed', errorInfo);
            }
          }
        >
          <Row
            gutter={24}
          >
            <Col
              xs={{ span: 24 }}
              lg={{ span: 14 }}
            >
              <span
                className="service-title"
              >
                Detalhes da solicitação
              </span>
            </Col>
            <Col
              xs={{ span: 24 }}
              lg={{ span: 10 }}
            >
              <div
                className="buttons-container"
              >
                <Row
                  gutter={24}
                >
                  <Col
                    xs={{ span: 24 }}
                    md={{ span: 12 }}
                  >
                    <Button
                      className="btn-previous"
                      onClick={
                        () => navigate(`/service/estimates/${id}/details`)
                      }
                    >
                      Voltar
                    </Button>
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    md={{ span: 12 }}
                  >
                    <Form.Item
                      noStyle
                    >
                      <Button
                        className="btn-edit"
                        type="primary"
                        htmlType="submit"
                      >
                        Salvar
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          <div
            className="inner-container"
          >
            <Row
              gutter={24}
            >
              <Col
                xs={{ span: 24 }}
                lg={{ span: 11 }}
              >
                <div>
                  <Row
                    gutter={24}
                  >
                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        className="item-title"
                      >
                        Data/hora da solicitação
                      </p>
                      <p
                        className="item-descripetion"
                      >
                        {
                          (solicitationDate
                            ? moment(solicitationDate)
                              .format('DD/MM/YYYY [às] HH:mm') : '')
                        }
                      </p>
                    </Col>

                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        className="item-title"
                      >
                        Serviço/tipo de serviço
                      </p>
                      <p
                        className="item-descripetion"
                      >
                        {dataServiceName}
                        {!!dataServiceTypeName && `: ${dataServiceTypeName}`}
                      </p>
                    </Col>
                  </Row>

                  <Row
                    gutter={24}
                  >
                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        className="item-title"
                      >
                        Filial
                      </p>
                      <p
                        className="item-descripetion"
                      >
                        {nomeFilial ? nomeFilial : '-'}
                      </p>
                    </Col>

                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        className="item-title"
                      >
                        CTC responsável
                      </p>
                      <p
                        className="item-descripetion"
                      >
                        {ctcResponsavel ? ctcResponsavel : '-'}
                      </p>
                    </Col>
                  </Row>

                  <Row gutter={24}>
                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        className="item-title"
                      >
                        Usuário que solicitou
                      </p>
                      <p
                        className="item-descripetion"
                      >
                        {dataUserNameThatRequestedTheService}
                      </p>
                    </Col>

                    {
                      userType === 'COOPERCITRUS'
                      && (
                        <Col
                          xs={{ span: 12 }}
                          lg={{ span: 12 }}
                        >
                          <p
                            className="item-title"
                          >
                            Usuário responsável
                          </p>
                          <Form.Item
                            label=""
                            name="responsableUser"
                            rules={[]}
                            initialValue={
                              dataResponsableUserId
                                ? dataResponsableUserId.toString()
                                : undefined
                            }
                          >
                            <Select
                              showSearch
                              allowClear
                              style={{ width: '100%' }}
                              placeholder="Selecione o usuário responsável"
                              filterOption={
                                (input, option) => option
                                  .props
                                  .children
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                            >
                              {userOptions}
                            </Select>
                          </Form.Item>
                        </Col>
                      )
                    }

                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        className="item-title"
                      >
                        Status
                      </p>
                      <p
                        className="item-descripetion"
                      >
                        {dataStatus}
                      </p>
                    </Col>

                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        className="item-title"
                      >
                        Responsável pelo orçamento
                      </p>
                      <p
                        className="item-descripetion"
                      >
                        {
                          !dataResponsableBudget
                            ? '(Nenhum)'
                            : dataResponsableBudget
                        }
                      </p>
                    </Col>

                    {
                      (dataReasonRefuses !== null && dataReasonRefuses !== '' && dataStatus !== 'Orçamento aprovado')
                        ? (
                          <Col
                            xs={{ span: 12 }}
                            lg={{ span: 12 }}
                          >
                            <p
                              className="item-title"
                            >
                              Motivo da recusa:
                            </p>
                            <p
                              className="item-descripetion"
                            >
                              {dataReasonRefuses}
                            </p>
                          </Col>
                        )
                        : ''
                    }

                    {
                      (dataDescriptionRefuse !== null && dataDescriptionRefuse !== '' && dataStatus !== 'Orçamento aprovado')
                        ? (
                          <Col
                            xs={{ span: 12 }}
                            lg={{ span: 12 }}
                          >
                            <p
                              className="item-title"
                            >
                              Descrição da recusa:
                            </p>
                            <p
                              className="item-descripetion"
                            >
                              {dataDescriptionRefuse}
                            </p>
                          </Col>
                        )
                        : ''
                    }







                    {
                      dataSchedulingDate
                      && (
                        <Col
                          xs={{ span: 12 }}
                          lg={{ span: 12 }}
                        >
                          <p
                            className="item-title"
                          >
                            <span
                              className="field-required-symbol"
                            >
                              *
                            </span>
                            Data do agendamento
                          </p>
                          <Form.Item
                            label=""
                            name="schedulingDate"
                            rules={[{ validator: validateSchedulingDate }]}
                            initialValue={
                              dataSchedulingDate.value !== '' && dataSchedulingDate.value !== null
                                ? moment(dataSchedulingDate.value, 'YYYY-MM-DDTHH:mm:ss.SSSZZ')
                                : null
                            }
                          >
                            <DatePicker
                              style={{ width: '100%' }}
                              placeholder="Data de agendamento"
                              format="DD/MM/YYYY"
                            />
                          </Form.Item>
                        </Col>
                      )
                    }
                  </Row>

                  <Row
                    className="param-row"
                  >
                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        className="item-title item-title-required"
                      >
                        Telefone para contato
                      </p>

                      {(
                        getUserType() !== 'COOPERCITRUS'
                          ? (
                            <p>
                              {dataTelephone}
                            </p>
                          )
                          : (
                            <Form.Item
                              label=""
                              name="telephone"
                              validateTrigger={['onBlur']}
                              rules={[
                                {
                                  required: true,
                                  message: 'Por favor, insira um telefone.',
                                },
                                {
                                  min: 14,
                                  message: 'Telefone inválido',
                                },
                              ]}
                            >
                              <MaskedInput
                                guide={false}
                                mask={mask}
                                placeholder="(00) 00000-0000"
                                className="ant-input"
                                maxLength={15}
                              />
                            </Form.Item>
                          )
                      )}
                    </Col>
                  </Row>

                  {
                    dataReasonForCancellation
                    && (
                      <Row
                        gutter={24}
                      >
                        <Col
                          xs={{ span: 24 }}
                          lg={{ span: 24 }}
                        >
                          <p
                            className="item-title"
                          >
                            Motivo do cancelamento
                          </p>
                          <Form.Item
                            label=""
                            name="reasonForCancellation"
                            rules={[
                              { required: true, message: 'Por favor, insira o motivo do cancelamento' },
                              { max: 200, message: 'Máximo de 200 caracteres' },
                            ]}
                            initialValue={dataReasonForCancellation}
                          >
                            <Input.TextArea
                              placeholder="Motivo do cancelamento"
                              rows={4}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    )
                  }

                  <Row
                    className="param-row"
                  >
                    <Col>
                      <p
                        className="item-title"
                      >
                        Informações adicionais
                      </p>
                      Matrícula:&nbsp;
                      {dataMatriculationNumber}
                    </Col>
                  </Row>

                  <Row
                    className="param-row"
                  >
                    <Col>
                      Cooperado:&nbsp;
                      {dataLandOwnerName}
                    </Col>
                  </Row>

                  <Row
                    className="param-row"
                  >
                    <Col>
                      Propriedade:&nbsp;
                      {dataLandName}
                    </Col>
                  </Row>

                  {
                    serviceTypeDynamicFields.length > 0
                      && !isRestructured
                      ? (
                        <div
                          style={{ marginTop: 15 }}
                        >
                          {serviceTypeDynamicFields.filter(filter).map(renderDynamicField)}
                        </div>
                      )
                      : null
                  }

                  {
                    dataServiceSubTypeName
                    && (
                      <Row
                        className="param-row"
                        style={{ marginTop: 15 }}
                      >
                        <Col>
                          Tipo:
                          <span style={{ float: 'right' }}>
                            {dataServiceSubTypeName}
                          </span>
                        </Col>
                      </Row>
                    )
                  }
                  {
                    (dataServiceName && dataServiceName !== 'Grid')
                      && !isRestructured
                      ? serviceSubtypeDynamicFields.filter(filter).map(renderSubtypeDynamicField)
                      : (
                        <GridFields
                          form={formInstance}
                          data={dataShare}
                        />
                      )
                  }
                </div>

                {
                  isRestructured
                    ? (
                      <Row
                        gutter={[24, 24]}
                        className="EditEstimate__RequestFieldsRowContainer"
                      >
                        <Col
                          xs={{ span: 24 }}
                        >
                          <ServiceRequestFieldsRenderer
                            detail={true}
                            edit={true}
                            formInstance={formInstance}
                            serviceName={dataServiceName}
                            serviceTypeName={dataServiceTypeName}
                            serviceSubTypeName={dataServiceSubTypeName}
                            labelClassName="EditEstimate__RequestFieldLabel"
                            initialValuesObject={
                              Object.fromEntries(
                                serviceRequestFields.map(
                                  (val) => {
                                    return [val.idCode, val.value];
                                  },
                                ),
                              )
                            }
                            allRequestParams={{
                              attachments: allRequestData.attachments,
                              id: allRequestData.id,
                              landFields: allRequestData.landFields,
                              landName: allRequestData.landName,
                              landOwnerName: allRequestData.landOwnerName,
                              matriculationNumber: allRequestData.matriculationNumber,
                              reasonForCancellation: allRequestData.reasonForCancellation,
                              responsableUser: allRequestData.responsableUser,
                              schedulingDate: allRequestData.schedulingDate,
                              serviceName: allRequestData.serviceName,
                              serviceRequestFields: allRequestData.budgetRequestFields,
                              budgetRequestNotes: allRequestData.budgetRequestNotes,
                              serviceSubtype: allRequestData.serviceSubtype,
                              serviceSubtypeDynamicFields:
                                allRequestData.serviceSubtypeDynamicFields,
                              serviceSubtypeName: allRequestData.serviceSubtypeName,
                              serviceTypeDynamicFields: allRequestData.serviceTypeDynamicFields,
                              serviceTypeName: allRequestData.serviceTypeName,
                              serviceTypeId: allRequestData.serviceTypeId,
                              solicitationDate: allRequestData.solicitationDate,
                              status: allRequestData.status,
                              telephone: allRequestData.telephone,
                              userNameThatRequestedTheService:
                                allRequestData.userNameThatRequestedTheService,
                            }}
                          />
                        </Col>
                      </Row>
                    )
                    : null
                }

                <Row
                  className="param-row"
                >
                  <Col>
                    <p
                      className="item-title"
                    >
                      Observações
                    </p>
                  </Col>
                </Row>

                <Row>
                  {
                    userType === 'COOPERCITRUS'
                    && renderObs(false)
                  }
                </Row>

                <Row
                  className="param-row"
                >
                  <Col>
                    <p
                      className="item-title"
                    >
                      Observações da Coopercitrus
                    </p>
                  </Col>
                </Row>

                <Row>
                  {
                    userType === 'COOPERCITRUS'
                    && renderObs(true)
                  }
                </Row>

                <Row>
                  <Button
                    className="btn-previous"
                    onClick={addObs}
                  >
                    Adicionar observações
                  </Button>
                </Row>
              </Col>

              <Col
                xs={{ span: 24 }}
                lg={{ span: 12, offset: 1 }}
                style={{ paddingTop: 15 }}
              >
                <SelectedLands
                  talhoesSelecionados={
                    dataLandFields.map(
                      (v) => ({
                        ...v,
                        culture: {
                          description: v.culture,
                        },
                      }),
                    )
                  }
                />
                <div
                  className="attachments-container"
                >
                  <Row
                    className="param-row"
                  >
                    <div
                      className="field-title-text"
                      style={{ marginBottom: 8 }}
                    >
                      Anexos
                    </div>
                  </Row>
                  <div
                    className="attachments-items-container"
                  >
                    <UploadFiles
                      typeUser="BUDGET_REQUEST_COOPERCITRUS_FILE"
                      ref={uploadFilesReference}
                      requestType="ORCAMENTO"
                      origin="edit"
                      id={dataId}
                      fileSize={valueAttachmentSizeCoopercitrus.current}
                      action="edit"
                      initialFiles={
                        dataAttachments.map((item) => ({ ...item, uid: item.id, status: 'done' }))
                      }
                    />
                  </div>
                </div>

                <div>
                  <div className="param-row">
                    <div
                      className="item-title"
                      style={{ marginBottom: 8 }}
                    >
                      Orçamento
                    </div>
                  </div>

                  <Row gutter={24} style={{ backgroundColor: '#f7f9fa', padding: '.7rem' }}>
                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        className="item-title item-title-required"
                      >
                        Valor unitário
                      </p>

                      <Form.Item
                        label=""
                        name="valorUnitario"
                      >
                        <CurrencyInput
                          className="ant-input"
                          decimalSeparator=","
                          thousandSeparator="."
                          placeholder="0,00"
                          step={0.01}
                          data-id="1"
                          min={0}
                          disabled={requestedBranch}
                        />
                      </Form.Item>
                    </Col>

                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        className="item-title item-title-required"
                      >
                        Valor total
                      </p>

                      <Form.Item
                        label=""
                        name="valorTotal"
                      >
                        <CurrencyInput
                          className="ant-input"
                          decimalSeparator=","
                          thousandSeparator="."
                          placeholder="0,00"
                          step={0.01}
                          data-id="1"
                          min={0}
                          disabled={requestedBranch}
                        />
                      </Form.Item>
                    </Col>

                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        className="item-title item-title-required"
                      >
                        Condição de pagamento
                      </p>

                      <Form.Item
                        label=""
                        name="condicaoPagamento"
                      >
                        <Input
                          placeholder="Insira uma condição de pagamento"
                          type="text"
                          maxLength="254"
                          className="ant-input"
                          disabled={requestedBranch}
                        />
                      </Form.Item>
                    </Col>

                    <Col
                      xs={{ span: 12 }}
                      lg={{ span: 12 }}
                    >
                      <p
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        className="item-title item-title-required"
                      >
                        Forma de pagamento
                      </p>

                      <Form.Item
                        label=""
                        name="formaPagamento"
                      >
                        <Input
                          placeholder="Insira uma forma de pagamento"
                          type="text"
                          maxLength="254"
                          className="ant-input"
                          disabled={requestedBranch}
                        />
                      </Form.Item>
                    </Col>

                    <Col
                      xs={{ span: 24 }}
                      lg={{ span: 24 }}
                    >
                      <p
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        className="item-title"
                      >
                        Observações do orçamento
                      </p>

                      <Form.Item
                        label=""
                        name="obsOrcamento"
                      >
                        <Input.TextArea
                          type="text"
                          maxLength="1499"
                          className="ant-input"
                          disabled={requestedBranch}
                        />
                      </Form.Item>
                    </Col>

                    {
                      dataStatus === 'Orçamento pendente' || dataStatus === 'Orçamento recusado' || dataStatus === 'Orçamento expirado' ? (
                        <Col
                          xs={{ span: 24 }}
                          lg={{ span: 24 }}
                          style={{ textAlign: 'right' }}
                        >
                          <Button
                            className="btn-edit"
                            type="primary"
                            onClick={() => {
                              setLoading(true);
                              const requiredFormBranch = verifyRequiredFormBranch();

                              if (requiredFormBranch) {
                                message.warning('Por favor, preencha os campos obrigatórios de orçamento.');
                                setLoading(false);
                              } else {
                                setVisibleModalConfirmStatus(true);
                              }
                            }}
                            loading={loading}
                          >
                            Salvar orçamento e notificar cliente
                          </Button>
                        </Col>
                      )
                        : ''
                    }
                  </Row>
                </div>

              </Col>
            </Row>
          </div>

          <Modal
            wrapClassName="editService-user-modal"
            title={
              <h3 style={{ margin: 0 }}>Deseja mesmo continuar?</h3>
            }
            visible={visibleModalConfirmStatus}
            confirmLoading={confirmLoading}
            okText="Confirmar"
            cancelText="Cancelar"
            onOk={() => handleSubmitBranch()}
            onCancel={() => {
              setConfirmLoading(false);
              setLoading(false);
              setVisibleModalConfirmStatus(false);
            }}
          >
            <p>Uma vez confirmado, não será possível editar o orçamento!</p>
          </Modal>

          <Modal
            wrapClassName="EditEstimate-status-modal"
            width={1000}
            title={<h3 style={{ margin: 0 }}>Status da solicitação</h3>}
            visible={visibleModalStatus}
            onCancel={() => { setVisibleModalStatus(false); }}
            footer={[]}
          >
            {
              // destroys element if not active
              visibleModalStatus
              && (
                <ServiceStatusComponent
                  loading={false}
                  statusesList={statusesList}
                  currentStatusIndex={currentStatusIndex}
                  canceled={canceled}
                />
              )
            }
          </Modal>
        </Form>
      </Spin>

      <Modal
        wrapClassName="editService-user-modal"
        title={(
          <h3
            style={{ margin: 0 }}
          >
            Deseja mesmo continuar?
          </h3>
        )}
        visible={visibleModalResponsable}
        okText="Sim, prosseguir"
        cancelText="Não, quero revisar"
        onOk={() => handleSubmit(formValueTemp)}
        onCancel={
          () => {
            setVisibleModalResponsable(false);
          }
        }
      >
        <p>
          {`Ao prosseguir, as observações Coopercitrus que tenham sido adicionadas com a opção
          “Privada” desmarcada, serão exibidas e notificadas para o cooperado. Deseja mesmo
          continuar?`}
        </p>
      </Modal>
    </div>
  );
};

EditEstimate.propTypes = {};

EditEstimate.defaultProps = {};

export default EditEstimate;
